module.exports = __webpack_public_path__ + "static/media/DiscGolfSmall.1d8e89a2.jpg";